// =========================================
// Project Gallery — Load More
// Reveals hidden gallery items in batches (step = initial visible count).
// Hides the button once every item is shown.
// Figma: 329:8077 (LOAD MORE → 329:8123)
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    const galleries = document.querySelectorAll('[data-project-gallery]');
    if (!galleries.length) return;

    galleries.forEach(function (gallery) {
        const items = Array.from(gallery.querySelectorAll('[data-pgal-item]'));
        const btn = gallery.parentElement.querySelector('[data-pgal-load-more]');
        if (!btn || !items.length) return;

        const step = parseInt(gallery.dataset.pgalStep, 10) || items.length;
        let visible = items.filter(function (i) { return !i.classList.contains('d-none'); }).length;

        const sync = function () {
            if (visible >= items.length) btn.classList.add('d-none');
        };

        sync();

        btn.addEventListener('click', function () {
            const next = Math.min(visible + step, items.length);
            for (let i = visible; i < next; i++) {
                items[i].classList.remove('d-none');
            }
            visible = next;
            sync();
        });
    });
});
